import Video from "./components/Video";
import Contact from "./components/Contact";
import SEO from "../../components/common/SEO";

const index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Youstad",
    "description": "Get in touch with Youstad for academy management solutions. Contact us for support, sales, or partnership opportunities.",
    "url": "https://youstad.com/contact",
    "mainEntity": {
      "@type": "Organization",
      "name": "Youstad",
      "url": "https://youstad.com",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": "English"
      }
    }
  };

  return (
    <>
      <SEO
        title="Contact Youstad | Get Support & Academy Management Solutions"
        description="Get in touch with Youstad for academy management solutions. Contact us for support, sales, or partnership opportunities. We're here to help optimize your academy operations."
        keywords="contact youstad, academy support, educational software support, academy management help, youstad contact, academy solutions"
        url="https://youstad.com/contact"
        structuredData={structuredData}
      />
      <Video />
      <Contact />
    </>
  );
};

export default index;
